/* global navigator */
import Cookies from 'js-cookie';

export const logEvent = async (category, title) => {
  const url = 'https://apigateway.commerce7.com/lambdas/analytic/update';

  await fetch(url, {
    method: 'post',
    keepalive: true,
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ category, title })
  });
};

const randomId = () =>
  [...Array(36)].map(() => Math.random().toString(36)[2]).join('');

export const getVisitorId = () => {
  const visitorId = Cookies.get('visitorId');
  return visitorId;
};

export const createVisitorId = () => {
  let visitorId = Cookies.get('visitorId');
  if (!visitorId) {
    visitorId = randomId();
    Cookies.set('visitorId', visitorId);
  }
  return visitorId;
};

export const getDeviceType = () => {
  let deviceType = 'Desktop';
  if (navigator.userAgent.toLowerCase().match(/mobile/i)) {
    deviceType = 'Mobile';
  }
  if (navigator.userAgent.toLowerCase().match(/tablet/i)) {
    deviceType = 'Tablet';
  }
  return deviceType;
};
